<div *ngIf="form">
  <ion-item>
    <bones-form-label [item]="item"></bones-form-label>
    <ion-toggle slot="end" [(ngModel)]="toggleValue" (ionChange)="onToggle()" [disabled]="item.readonly"></ion-toggle>
  </ion-item>
</div>
